import React from "react";
import Mailto from "react-mailto";
import Helmet from "react-helmet";

import "./serverless.css";

export default function Index() {
	const email = "mail@andrewgriffithsonline.com",
		subject = "Introduction to Serverless Training";

	return (
		<main className="container container-page training">
			<Helmet
				title="Introduction to Serverless on AWS Lambda | Training Workshops"
				meta={[
					{
						name: "description",
						content:
							"Expert in person training workshop designed for those beginning serverless. It is hands on, practical focused on building and deploying a serverless API backed by a multi-region database using DynamoDB, AWS Lambda and API Gateway."
					},
					{
						name: "keywords",
						content:
							"serverless training, serverless workshops, aws serverless training, aws lambda training"
					}
				]}
			/>

			<h1>Introduction to Serverless on AWS Lambda</h1>
			<h4 className="duration">
				Two day in person workshop -{" "}
				<Mailto email={email} headers={{ subject }}>
					Drop me a line to book yours today!
				</Mailto>
			</h4>

			<h4>Overview</h4>
			<p>
				This training course is the distillation of the knowledge I{"'"}ve
				gained from helping companies run serverless infrastructures over the
				last two years. It{"'"}s designed to give engineers the skills to build
				and run production grade serverless systems.
			</p>

			<p>
				The workshop is designed for those beginning serverless. It is hands on,
				practical focused. Partipants are guided through the process of building
				and deploying a serverless API backed by a multi-region database using
				DynamoDB, AWS Lambda, API Gateway and Route53.
			</p>

			<h4>Learn how to:</h4>
			<ul>
				<li>Build a simple Serverless REST API</li>
				<li>
					Deploy to AWS Lambda & API Gateway using AWS Cloudformation and Simple
					Application Model (SAM)
				</li>
				<li>Add persistence with multi-region serverless databases</li>
				<li>Architect event driven systems</li>
				<li>Log & monitor serverless applications</li>
				<li>Troubleshoot real life production serverless problems</li>
				<li>Create a Serverless Data Pipeline</li>
				<li>
					Setting up a CI/CD pipeline to deploy your serverless application
				</li>
			</ul>

			<h4>Prerequisites</h4>
			<ul>
				<li>Basic programming knowledge</li>
			</ul>

			<h4>Recommended audience</h4>
			<ul>
				<li>Developers beginning serverless</li>
				<li>
					Developers with some knowledge of serverless who want to learn best
					practices for production grade serverless applications
				</li>
			</ul>

			<h4>Book Your Training</h4>
			<p>
				<Mailto email={email} headers={{ subject }}>
					Get in touch
				</Mailto>{" "}
				to book this training for your organisation.
			</p>
		</main>
	);
}



// WEBPACK FOOTER //
// ./src/pages/training/introduction-to-serverless-on-aws.js